import "core-js/modules/es.object.to-string.js";
import { request } from "@/js/http/http_request";
export default {
  name: "MvtStockDetailsPopin",
  data: function data() {
    return {
      isEditing: false,
      isSaving: false,
      reason: "",
      dialog: false,
      mvtStock: null,
      resolve: null,
      reject: null
    };
  },
  methods: {
    saveReason: function saveReason() {
      this.isSaving = true;
      var _this = this;
      request("/v1/mvt-stocks/".concat(this.mvtStock.id_mvt_stock, "/reason"), "put", {
        reason: this.reason
      }, true, "api").then(function () {
        _this.dialog = false;
        _this.resolve(true);
        _this.$toasted.show("Reason updated.", {
          type: "success"
        });
        _this.$emit("save-success");
      }).catch(function () {
        _this.$toasted.show("Unable to update the reason.", {
          type: "error"
        });
      }).finally(function () {
        _this.isSaving = false;
        _this.isEditing = false;
      });
    },
    open: function open(mvtStock) {
      var _this2 = this;
      this.dialog = true;
      this.mvtStock = mvtStock;
      this.reason = mvtStock.mvt_reasons;
      return new Promise(function (resolve, reject) {
        _this2.resolve = resolve;
        _this2.reject = reject;
      });
    },
    cancel: function cancel() {
      this.resolve(false);
      this.dialog = false;
    }
  }
};